import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

export const navigateToSignIn = () => {
  history.push("/sign-in"); 
};
